import type { AuditEntityType, ConfigAuditEntry, Page } from '@servicetim/shared';
import { adminPath, useApiContext } from './client';
import { DEFAULT_PAGE_SIZE, pageQuery, usePagedList } from './paging';

export interface AuditFilters {
  entityType?: AuditEntityType;
  entityId?: string;
  actorUserId?: string;
  /** ISO datetimes. */
  since?: string;
  until?: string;
}

/** `GET /admin/v1/audit?entityType=&entityId=&actorUserId=&since=&until=` */
export function useAuditLog(filters: AuditFilters = {}, pageSize = DEFAULT_PAGE_SIZE) {
  const { request, keys } = useApiContext();
  return usePagedList<ConfigAuditEntry>({
    queryKey: keys.audit.list({ ...filters, pageSize }),
    fetchPage: (cursor, signal) =>
      request<Page<ConfigAuditEntry>>('GET', adminPath('/audit'), {
        query: { ...filters, ...pageQuery(cursor, pageSize) },
        signal,
      }),
  });
}
